module.exports = __webpack_public_path__ + "static/media/setup-guide-outline.0d1a1343.svg";